<script setup>
import Layout from '../Layouts/App'
import { Head } from '@inertiajs/vue3'
import ErrorDice from "../Components/ErrorDice.vue";
import {ref} from "vue";

const props = defineProps({
    title: String,
    status: Number,
    theme: String
});


const dice = ref(null);
const roll = ref(null);

const click = () => {
    dice.value.onClick();
}

const onRoll = (result) => {
    roll.value = result;
}
</script>

<template>
    <Layout :theme="theme">
        <Head>
            <title>{{ title }}</title>
        </Head>
        <div class="max-w-full w-[1536px] mx-auto px-6 relative pt-10">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 2xl:grid-cols-3">
                <div class="md:order-2 text-center 2xl:col-span-2">
                    <div class="m-auto max-h-[60vh] max-w-[70vw] xl:max-w-[50vw] aspect-square">
                        <ErrorDice ref="dice" @roll="onRoll"/>
                    </div>
                </div>
                <div class="flex flex-col justify-end md:order-1">
                    <div class="flex-none pb-4 md:pb-12">
                        <h1 class="text-3xl -tracking-[0.04em] lg:text-5xl xl:text-6xl font-extrabold leading-none text-black dark:text-white">
                            <span v-if="!roll || (roll === 1)">Антикрит...</span>
                            <span v-else-if="roll < 10">Провал</span>
                            <span v-else>Успех!</span>
                        </h1>
                        <p class="mt-5 text-sm md:mt-7 md:text-xl xl:text-2xl !leading-normal">
                            <span v-if="!roll">
                                Ты в месте, которого не существует.<br>
                                Но шанс выбраться, пока остаётся.<br>
                                <strong>Сложность — 10</strong>
                            </span>
                            <span v-else-if="roll === 1">
                                Ваш персонаж заблудился окончательно<br>
                                После долгих блужданий...<br>
                                <strong>Вы погибли</strong>
                            </span>
                            <span v-else-if="roll < 10">
                                Ты все еще в месте, которого не существует.<br>
                                Но шанс выбраться, пока остаётся.<br>
                                <strong>Сложность — 10</strong>
                            </span>
                            <span v-else>
                                Поздравляем!<br>
                                Вы выбрались из передряги<br>
                                <strong>На этот раз</strong>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <a v-if="roll && (roll === 1)" href="javascript:void(0);" class="btn mt-4 text-orange opacity-50 pointer-events-none">
                <span class="btn-text">Бросить дайс</span>
                <span class="btn-hover-wrapper">
                    <span class="btn-hover">
                        <span>Потрачено</span>
                    </span>
                </span>
            </a>
            <a v-else-if="!roll || (roll < 10)" href="javascript:void(0);" class="btn mt-4 text-orange" @click="click">
                <span class="btn-text">Бросить дайс</span>
                <span class="btn-hover-wrapper">
                    <span class="btn-hover">
                        <span>Бросить дайс</span>
                    </span>
                </span>
            </a>
            <a v-else href="/" class="btn mt-4 text-orange" @click="click">
                <span class="btn-text">Бежать на главную</span>
                <span class="btn-hover-wrapper">
                    <span class="btn-hover">
                        <span>Бежать на главную</span>
                    </span>
                </span>
            </a>
        </div>
    </Layout>
</template>
